// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IIndexFile {
  name: string;
}
